




















































































































import Vue from "vue";

export default Vue.extend({
  name: "ChartRoomAverage",
  props: {
    roomInfo: {
      required: true,
      type: Object as () => {
        name: string;
        icon: string;
        color: string;
        temperature: number;
        humidity: number;
        type: string;
        min: {
          date: string;
          value: number;
        };
        max: {
          date: string;
          value: number;
        };
      },
    },
  },
  computed: {
    isPortugueseLocale(): boolean {
      return this.$i18n.locale === "pt" || this.$i18n.locale === "pt-PT";
    },
  },
  methods: {
    getDeviceOrRoomName(name: string): string {
      if (!name) return this.$t("devices.unknown") as string;
      const n = name
        ?.toLowerCase()
        ?.replaceAll(" ", "_")
        ?.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return this.$t(`devices.${n}`) as string;
    },
    getWeekDayOrTimeFromDate(d: string): string {
      if (!d) return "";

      /** We will handle two options, 1st. is converting to week day, 2nd. is converting to time which looks like 'Dia xx' */
      if (d.toLowerCase().includes("dia")) {
        return `${this.$t("common.day")} ${d.split(" ")[1] || ""}`;
      }

      const dateMaps: Record<string, string> = {
        segunda: "common.week.monday",
        terca: "common.week.tuesday",
        quarta: "common.week.wednesday",
        quinta: "common.week.thursday",
        sexta: "common.week.friday",
        sabado: "common.week.saturday",
        domingo: "common.week.sunday",
      };
      return `${this.$t(dateMaps[d.split(" ")[0].toLowerCase()] || "")}`;
    },
    getInformationType(type: string): string {
      if (!type) return "";

      const informationTypeMaps: Record<string, string> = {
        atual: "components.cards.label.current",
        semanal: "components.cards.label.weekly",
        mensal: "components.cards.label.monthly",
      };

      return this.$t(informationTypeMaps[type?.toLowerCase()] || "").toString();
    },
  },
});
